export default {
  data () {
    return {
      primaryColor: '#e7ecee',
      secondaryColor: '#fdfdfd'
    }
  }
}
